import { styled } from '@mui/material/styles';
import { Box, Tabs, Tab, TextField, Button } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
    display: 'flex',
    height: '100vh',
    backgroundColor: theme.palette.background.default,
}));

export const SidebarContainer = styled(Box)(({ theme }) => ({
    width: '320px',
    backgroundColor: theme.palette.background.paper,
    borderRight: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    overflowY: 'auto',
    borderRadius: '5px'
}));

export const ContentContainer = styled(Box)(() => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
}));

export const SearchBar = styled(TextField)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
        borderRadius: theme.shape.borderRadius,
    },
}));

export const FilterContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
        height: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.divider,
        borderRadius: '4px',
    },
}));

export const FilterButton = styled(Button)(({ theme, active }) => ({
    minWidth: 'auto',
    padding: theme.spacing(0.5, 1.5),
    fontSize: '0.75rem',
    backgroundColor: active ? theme.palette.secondary.main : 'transparent',
    color: active ? theme.palette.primary.contrastText : theme.palette.text.secondary,
    border: active ? 'none' : `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(1),
    '&:hover': {
        backgroundColor: active ? theme.palette.secondary.light : theme.palette.action.hover,
    },
}));

export const LawyerList = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: 1,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.divider,
        borderRadius: '4px',
    },
}));

export const LawyerItem = styled(Box)(({ theme, selected }) => ({
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5),
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: selected ? theme.palette.action.selected : 'transparent',
    border: `1px solid ${selected ? theme.palette.secondary.main : 'transparent'}`,
    '&:hover': {
        backgroundColor: selected ? theme.palette.action.selected : theme.palette.action.hover,
    },
}));

export const LawyerSpecialty = styled(Box)(({ theme, primary }) => {
    // Different colors for different specialties
    const getColor = () => {
        if (primary === 'corporate') return '#3949AB';
        if (primary === 'litigation') return '#D32F2F';
        if (primary === 'familyLaw') return '#7B1FA2';
        if (primary === 'propertyLaw') return '#388E3C';
        if (primary === 'criminalLaw') return '#FFA000';
        if (primary === 'intellectualProperty') return '#00796B';
        if (primary === 'laborLaw') return '#5D4037';
        return '#1976D2';
    };

    return {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: getColor(),
        textTransform: 'capitalize',
        padding: theme.spacing(0.25, 0.75),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: `${getColor()}15`,
        display: 'inline-block',
    };
});

export const LawyerLocation = styled(Box)(({ theme }) => ({
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.primary.main,
    },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 80,
    marginRight: theme.spacing(2),
    '&.Mui-selected': {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
}));

export const DetailPanel = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
}));

export const DetailHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const DetailContent = styled(Box)(() => ({
    flex: 1,
}));

export const DetailActions = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
}));

export const NoSelectionPlaceholder = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    padding: theme.spacing(4),
}));

export const MapContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
}));